module.exports = __webpack_public_path__ + "static/media/animal-frog3.f66b5bb0.aac";